
import React, { useEffect, useState, useRef } from "react";
import HighChartsColors from "../PreviewHighchart/HIghChartsColors.js";
import { decryptData } from "../utils/EncriptionStore";
import "./HighCharts.css";
import { toast } from "react-toastify";
import { Box, CircularProgress, Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableRow, TableHead, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import styles from './dashboardcustombox.module.css';
function DashboardCustomBox({ CustomBoxData, height, width, flagvalue }) {

    const user = (() => {
        const encryptedData = localStorage.getItem("profile");
        return encryptedData ? decryptData(encryptedData) : null;
    })();

    const [DataNotFount, setDataNotfound] = useState({ status: "", message: "" });
    const [columnCount, setcolumnCount] = useState(0);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (CustomBoxData?.len_col && CustomBoxData?.chart_type === "custombox") {
            setcolumnCount(CustomBoxData?.len_col);
        }
    }, [CustomBoxData]);

    const [legends, setLegends] = useState([]);
    // const [legendsReference, setLegendsReference] = useState([]);
    const [parsedColors, setParsedColors] = useState([]);
    const [defaultColors, setDefaultColors] = useState([]);

    const safeParseJSON = (jsonString) => {
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            console.error("Invalid JSON:", error);
            return null;
        }
    };

    useEffect(() => {
        if (!CustomBoxData) return;

        if (CustomBoxData?.chart_colours) {
            const colors =
                typeof CustomBoxData?.chart_colours === "string"
                    ? safeParseJSON(CustomBoxData?.chart_colours)
                    : CustomBoxData?.chart_colours;
            setParsedColors(colors || {});
        }

        const isSimpleChart = (type) =>
        (["custombox"].includes(type) &&
            columnCount <= 2);
        const extractLegends = () => {
            const legends = [];
            if (isSimpleChart(CustomBoxData?.chart_type)) {
                CustomBoxData?.xAxis?.forEach((item) => {
                    item?.categories?.forEach((category) => {
                        const nameAsString = String(category);
                        if (!legends.includes(nameAsString)) legends.push(nameAsString);
                    });
                });
            } else {
                CustomBoxData?.series?.forEach((seriesItem) => {
                    const nameAsString = String(seriesItem.name);
                    if (!legends.includes(nameAsString)) legends.push(nameAsString);
                });
            }
            return legends;
        };
        const newLegends = extractLegends();
        const parsedColorsval = CustomBoxData?.chart_colours
            ? typeof CustomBoxData?.chart_colours === "object"
                ? CustomBoxData?.chart_colours
                : safeParseJSON(CustomBoxData?.chart_colours)
            : {};

        if (Array.isArray(newLegends) && newLegends.length > 0) {
            if (parsedColorsval) {
                const validLegends = newLegends.filter(
                    (key) => parsedColorsval[key] !== undefined
                );
                const getRandomColors = (colors, count) => {
                    const shuffled = [...colors].sort(() => 0.5 - Math.random());
                    return shuffled.slice(0, count);
                };
                const defaultColorsForJson =
                    validLegends.length > 0
                        ? getRandomColors(
                            Object.values(HighChartsColors),
                            validLegends.length
                        )
                        : [];
                setDefaultColors(defaultColorsForJson);
                setLegends(validLegends);
            }
        }
    }, [columnCount, CustomBoxData]);

    const [chartColoursFromJson, setChartColoursFromJson] =
        useState(defaultColors);

    useEffect(() => {
        if (parsedColors && legends.length > 0) {
            const colorsInOrder = legends.map((legend) => parsedColors[legend]);
            setChartColoursFromJson(colorsInOrder);
        } else {
            setChartColoursFromJson([]);
        }
    }, [legends, parsedColors]);


    const getHighlightValue = () => {
        if (!CustomBoxData) return '';
        if (CustomBoxData.Total !== undefined) return CustomBoxData.Total;
        // Sum all numeric values
        return Object.values(CustomBoxData?.series[1]?.data).reduce((sum, val) => sum + (typeof val === 'number' ? val : 0), 0);
    };

    const handleClick = (key, category_name) => {
        if (CustomBoxData?.drilldown === 'yes') {
            const databox = { report_title: CustomBoxData?.title, category_name: category_name, category_value: key, drilldown_type: CustomBoxData?.drilldown_type, report_type: "custombox",len_col:CustomBoxData.len_con };
            openNewWindow(databox);
        } else {
            toast.warn("drilldown is not enabled !", { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "light", });
        }
    };

    const drilldownWindow = useRef(null);

    const openNewWindow = (datav) => {
        const queryString = new URLSearchParams(datav).toString();

        let url;
        if (datav?.drilldown_type === "dashboard") {
            url = `/dashboarddrilldown?${queryString}`;
        } else {
            url = `/drillDown?${queryString}`;
        }
        if (drilldownWindow.current && !drilldownWindow.current.closed) {
            drilldownWindow.current.location.href = url;
            drilldownWindow.current.focus();
        } else {
            drilldownWindow.current = window.open(url, "_blank", "width=600,height=400");
        }
    };


    return (
        <div>
            <div style={{ width: { width }, height: { height } }}>
                {DataNotFount?.status === 404 ? (
                    <div className="report_header_container">
                        <div className="report-name-show">{DataNotFount?.Report_name}</div>
                        <div className="data-check-message">{DataNotFount?.message}</div>
                    </div>
                ) : (
                    <div className={styles.card}
                        style={{
                            height: height ? (typeof height === "number" ? `${height}` : height) : "auto",
                            boxSizing: "border-box",
                            backgroundColor: CustomBoxData?.custombox_background_colour
                        }}
                    >
                        <div className={styles.header} style={{ color: CustomBoxData?.custombox_font_colour }}>
                            <span style={{ fontSize: CustomBoxData?.custombox_title_font_size }}>{CustomBoxData?.title}</span>
                        </div>
                        {CustomBoxData?.custombox_legend_position === "vertical" ? (
                            <div className={styles.verticalLayout}>
                                <div className={styles.highlightWrapper}>
                                    <span className={styles.highlightValue} style={{ color: CustomBoxData?.custombox_font_colour, fontSize: CustomBoxData?.custombox_value_font_size }}>{getHighlightValue()}</span>
                                    <span className={styles.highlightLabel}>
                                        {CustomBoxData?.chart_subtitle || ""}
                                    </span>
                                </div>
                                <div className={styles.verticalLegend}>
                                    {CustomBoxData?.series[0]?.data.map((key, index) => (
                                        <div key={key} className={styles.legendItemVertical} onClick={() => handleClick(key, CustomBoxData?.series[0]?.name)}>
                                            <span
                                                className={styles.badge}
                                                style={{ backgroundColor: chartColoursFromJson[index] }}
                                            >
                                                {CustomBoxData?.series[1]?.data[index]}
                                            </span>
                                            <span style={{ color: CustomBoxData?.custombox_legend_font_colour }}>{key}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className={styles.highlightWrapper}>
                                    <span className={styles.highlightValue} style={{ color: CustomBoxData?.custombox_font_colour, fontSize: CustomBoxData?.custombox_value_font_size }}>{getHighlightValue()}</span>
                                    <span className={styles.highlightLabel}>
                                        {CustomBoxData?.chart_subtitle || ""}
                                    </span>
                                </div>
                                <div className={styles.legend}>
                                    {CustomBoxData?.series[0]?.data.map((key, index) => (
                                        <div key={key} className={styles.legendItem} onClick={() => handleClick(key, CustomBoxData?.series[0]?.name)}>
                                            <span
                                                className={styles.badge}
                                                style={{ backgroundColor: chartColoursFromJson[index] }}
                                            >
                                                {CustomBoxData?.series[1]?.data[index]}
                                            </span>
                                            <span style={{ color: CustomBoxData?.custombox_legend_font_colour }}>{key}</span>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default DashboardCustomBox;
